<template>
  <div>
    <h2>Messages for this room:</h2>
    <span>You can select the messages you want to send for training to the Callboxs AI and press the Train button.</span>
    <br/><br/>

    <table border="1" style="width: 100%; border-collapse: collapse; text-align: left;">
      <thead>
        <tr>
          <th>
            <input type="checkbox" v-model="state.selectAll" @change="toggleSelectAll" />
          </th>
          <th>Question</th>
          <th>Answer</th>
          <th>From OpenAI</th>
          <th>For Training</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(message, index) in groupedMessages" :key="index">
          <td>
            <input type="checkbox" v-model="state.selectedMessages[index]" />
          </td>
          <td>{{ message.question }}</td>
          <td>{{ message.answer }}</td>
          <td>{{ message.isOpenAi ? "Yes" : "No" }}</td>
          <td>{{ message.forTraining ? "Yes" : "No" }}</td>
        </tr>
      </tbody>
    </table>
    
    <br/>
    <button @click="uploadToS3()">Train Callboxs AI</button>
  </div>
</template>

<script>
import { reactive, onMounted, computed } from 'vue';
import axios from 'axios';

export default {
  props: {
    docId: {
      type: String,
    },
  },
  setup(props) {
    const state = reactive({
      messages: [],
      selectedMessages: [],
      selectAll: false,
    });
    

    const roomId = computed(() => {
      return props.docId.replace('draft', 'published');
    });

    onMounted(async () => {
      try {
        const response = await axios.get(`/api/v1/chat-rooms/${roomId.value}`);
        state.messages = response.data._chatMessages;
        state.selectedMessages = new Array(groupedMessages.value.length).fill(false);
      } catch (error) {
        console.log(error);
      }
    });

    const groupedMessages = computed(() => {
      const sortedMessages = [...state.messages].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

      const groups = [];
      for (let i = 0; i < sortedMessages.length; i++) {
        const question = sortedMessages[i];
        if (question.messageType === "user") {
          const nextMessage = sortedMessages[i + 1];
          const isAnswer = nextMessage && nextMessage.messageType === "bot";

          groups.push({
            question: question.message,
            answer: isAnswer ? nextMessage.message : "No answer yet",
            isOpenAi: isAnswer ? nextMessage.fromOpenAi : false,
            forTraining: question.forTraining || false
          });
        }
      }
      return groups;
    });

    const toggleSelectAll = () => {
      if (state.selectAll) {
        state.selectedMessages = new Array(groupedMessages.value.length).fill(true);
      } else {
        state.selectedMessages = new Array(groupedMessages.value.length).fill(false);
      }
    };

    const uploadToS3 = async () => {
      const selectedData = groupedMessages.value
        .filter((_, index) => state.selectedMessages[index]);

      if (!selectedData.length) {
        alert("No rows selected!");
        return;
      }

      const escapeCSV = value =>
        typeof value === "string" && /[",\n]/.test(value)
          ? `"${value.replace(/"/g, '""')}"`
          : value;

      const csvContent = [
        ["Question", "Answer", "From OpenAI", "For Training"],
        ...selectedData.map(({ question, answer, isOpenAi, forTraining }) => [
          escapeCSV(question),
          escapeCSV(answer),
          isOpenAi ? "Yes" : "No",
          forTraining ? "Yes" : "No",
        ])
      ]
        .map(row => row.join(","))
        .join("\n");

      try {
        const folderPath = '';
        const filename = `selected_messages_${Date.now()}.csv`;
        const finalFilename = `${folderPath}${filename}`;

        const response = await axios.get("/api/v1/api-s3/get-s3-signed-url", {
          params: {
            filename: finalFilename,
            filetype: "text/csv",
          },
        });

        const { signedUrl } = response.data;

        await axios.put(signedUrl, csvContent, {
          headers: {
            "Content-Type": "text/csv"
          },
        });

        alert("Uploaded successfully to S3!");
        try {
          const date = new Date();
          await axios.patch(`/api/v1/chat-rooms/${roomId.value}?aposMode=published`,
            { sendForTraining: `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`});
          await axios.patch(`/api/v1/chat-rooms/${roomId.value}?aposMode=draft`,
            { sendForTraining: `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`});
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        alert("Failed to upload file. Please try again.");
      }
    };

    return {
      state,
      roomId,
      groupedMessages,
      toggleSelectAll,
      uploadToS3,
    }
  },
};
</script>

<style scoped>
  td, th{
    padding: 10px;
  }
  input[type="checkbox"] {
    padding: 10px;
    accent-color: #981d68;
  }
  button {
    float: right;
    background-color: #6516dd;
    color: white;
    padding: 10px 20px;
    border: 1px solid #5b14c7;
    font-size: 12px;
    font-family: -apple-system, system-ui, "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-weight: 500;
    border-radius: 8px;
  }
</style>